// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_q4-0";
export var buttonContainer = "_q4-3";
export var cancelButton = "_q4-4";
export var headerSection = "_q4-6";
export var headerTitle = "_q4-9";
export var messageSideLeft = "_q4-1";
export var messageSideRight = "_q4-2";
export var orderNumberContainer = "_q4-7";
export var orderNumberLabel = "_q4-8";
export var submitButton = "_q4-5";